import React from 'react';
import { compose, pick } from 'ramda';
import { withProps } from 'recompose';
import { useDeviceSelector } from 'js/store/hooks';
import { Card, CardBody, CardName } from '../../common/Card';
import withCardInfo from './withCardInfo';
import Row from './CardInfoRow';
import Media from './Media';
import Actions from './Actions';
import style from './index.scss';

export const RaceListCard = ({
    className = '',
    image,
    status,
    registrationStatus,
    leaderboardEndTime: endTime,
    leaderboardStartTime: startTime,
    name,
    leaderboardId,
    racesPositioning,
    cardInfoRows,
    joined,
    displayCountdown,
    participantsCount,
    maxParticipantsCount,
    countdownType,
    isRegInternal
}) => (
    <Card className={`${style.card} ${style[racesPositioning] || ''} ${isRegInternal ? style.internal : ''} ${className}`}>
        <Media {...{ status, endTime, startTime, displayCountdown, countdownType, image, isRegInternal }} />
        <CardBody className={style.body}>
            <CardName className={style.name} name={name} />
            <div className={style.infoContainer}>
                {cardInfoRows.map((row, idx) => <Row key={idx} items={row} />)}
            </div>
            <Actions
                className={style.actions}
                {...{ leaderboardId, registrationStatus, joined, participantsCount, maxParticipantsCount }} />
        </CardBody>
    </Card>
);

export const withCardType = withProps(
    () => {
        const { isMobile, isDesktop, isLandscape, isTablet, isPortrait } =
            useDeviceSelector(pick(['isMobile', 'isDesktop', 'isLandscape', 'isTablet', 'isPortrait']));

        return {
            isWideCard: isDesktop || isTablet && isLandscape,
            isMiddleCard: isTablet && isPortrait || isMobile && isLandscape,
            isNarrowCard: isMobile && isPortrait
        };
    }
);

export const withCardImage = withProps(
    ({ isMiddleCard, isNarrowCard, bannerUrl, mediumSizeImage, smallSizeImage }) => ({
        image: isNarrowCard
            ? smallSizeImage || mediumSizeImage || bannerUrl
            : isMiddleCard
                ? mediumSizeImage || bannerUrl
                : bannerUrl
    })
);

export default compose(
    withCardType,
    withCardInfo,
    withCardImage
)(RaceListCard);
